export const PA_INSURANCE_STEPS = {
    LANDING: 'step-0-1',
    CHOOSE_INSURANCE: 'step-1-1',
    BEGIN_DATE: 'step-1-2',
    CUSTOMER_LOGIN: 'step-1-3',
    POLICYHOLDER: 'step-1-4',
    INSURED_PERSONS: 'step-1-5',
    SUMMARY: 'step-1-6',
    PAYMENT: {
        OPTIONS: 'step-2-1',
        METHOD_TYPE: 'step-2-2',
        METHOD: 'step-2-3',
    },
};
